// extracted by mini-css-extract-plugin
export default {"configuratorModal":"views-ProductPage-configurators-styles__configuratorModal--tZXzf","messages":"views-ProductPage-configurators-styles__messages--rOPHc"};